import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lms-not-avaliable',
  templateUrl: './not-avaliable.component.html',
  styleUrls: ['./not-avaliable.component.scss']
})
export class NotAvaliableComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    const lang = navigator.language;
    const userLang = lang.slice(0, 2);
    localStorage.setItem('backofficelanguage', userLang);
  }
}
